export default "__VITE_ASSET__CPIQ6RWM__"